import { colors } from "./colors";
import GloablStyle from "./GlobalStyle.styles";

export const theme = {
  colors,
};

export default GloablStyle;
